import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';

export const SidebarContainer = styled.aside`
    position: absolute;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    align-items: center;
    left: 0;
    transition: all 0.5s ease;
    ${props => props.isOpen ?
    `top: 0
            `
    :
    `top: -100vh;
            `
  }
`

export const SidebarProfile = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 80px);
    text-align: center;
    list-style: none;
    padding: 0;
`

export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 80px);
    text-align: center;
    list-style: none;
    margin: 90px 0 0 0;
    padding: 0;
`

export const SidebarLink = styled(Link)`
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    padding: 0 2rem;
    height: 100%;
    width: 100%;
    cursor: pointer;

    &:hover {
      color: #1861A6;
      background: rgba(0,0,0,0.1)
    }
`